import { render, staticRenderFns } from "./AvisoSelf.vue?vue&type=template&id=29745d80&scoped=true&"
import script from "./AvisoSelf.vue?vue&type=script&lang=js&"
export * from "./AvisoSelf.vue?vue&type=script&lang=js&"
import style0 from "./AvisoSelf.vue?vue&type=style&index=0&id=29745d80&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29745d80",
  null
  
)

export default component.exports